import { useState, useEffect, useCallback } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { useSwiggyHeaders } from "context/SwiggyHeadersContext";
import { isUserLoggedIn } from "@swiggy-private/gamification-frontend-ui/dist/utils";
interface IUserLoginState {
    userLoggedIn: boolean;
    isLoading: boolean;
    hasHeaders: boolean;
}

export const useFetchUserLoggedIn = (): IUserLoginState => {
    const { headers } = useSwiggyHeaders();
    const [state, setState] = useState<IUserLoginState>({
        userLoggedIn: false,
        isLoading: true,
        hasHeaders: false,
    });

    const initHeaders = useCallback(async () => {
        try {
            const hasValidHeaders = !isEmpty(headers);
            const loggedIn = hasValidHeaders ? isUserLoggedIn(headers) : false;

            setState({
                userLoggedIn: loggedIn,
                isLoading: false,
                hasHeaders: hasValidHeaders,
            });
        } catch (error) {
            setState((prev) => ({
                ...prev,
                isLoading: false,
                hasHeaders: false,
            }));
        }
    }, [headers]);

    useEffect(() => {
        initHeaders();
    }, [headers, initHeaders]);

    return state;
};
